export enum BillingPlanEnum {
  Virtual = 'virtual',
  Stripe = 'stripe',
}
